// extracted by mini-css-extract-plugin
export default {"page":"styles_page__tcjaG","main":"styles_main__6pDN2","mainLogo":"styles_mainLogo__lhhiN","notCentered":"styles_notCentered__W4ZE0"};